import { useNavigate } from "react-router-dom";

/* ============================================================
   Struttura a schede sopra /conversazioni: da quando esiste anche
   `ConversazioniSessioniList` (le conversazioni vere, non solo le pratiche
   che ne sono nate) l'area "Agente" ha due elenchi distinti mai collegati fra
   loro — l'utente doveva sapere a memoria che esisteva una seconda pagina.
   Due rotte separate (`/conversazioni` e `/conversazioni/sessioni`), non due
   stati della stessa pagina: cosi' restano bookmarkabili e il pattern
   ricalca App.tsx (segmento letterale prima del dinamico `/conversazioni/:id`,
   come gia' per `ddt/queue` prima di `ddt/:id`). Questa barra e' solo il modo
   per passare dall'una all'altra senza tornare alla sidebar. */

export type AgenteTab = "conversazioni" | "pratiche";

export function AgenteTabs({ active }: { active: AgenteTab }) {
  const navigate = useNavigate();
  return (
    <div className="flow-tab-bar" style={{ marginBottom: "var(--space-3)" }}>
      <button
        type="button"
        className={`flow-tab${active === "conversazioni" ? " active" : ""}`}
        onClick={() => navigate("/conversazioni/sessioni")}
      >
        <span className="material-symbols-outlined" style={{ fontSize: "var(--font-size-md)" }}>forum</span>
        <span className="flow-tab-label">Conversazioni</span>
      </button>
      <button
        type="button"
        className={`flow-tab${active === "pratiche" ? " active" : ""}`}
        onClick={() => navigate("/conversazioni")}
      >
        <span className="material-symbols-outlined" style={{ fontSize: "var(--font-size-md)" }}>description</span>
        <span className="flow-tab-label">Pratiche</span>
      </button>
    </div>
  );
}
